module.exports = window["nab"]["segmentationRuleLibrary"];